import { Option, Select } from "../select";
import { useState, useEffect, useContext } from "react";
import { TypesValue } from "../contexts/types";
export default function AppType({ value, onChange, params }) {
  const [_value, setValue] = useState("");
  const types = useContext(TypesValue);

  useEffect(() => {
    if (value) {
      setValue(value);
    } else {
      setValue("");
    }
  }, [value]);

  const handleSelect = (v) => {
    setValue(v);
    onChange(v);
  };
  return (
    <div>
      <Select onChange={handleSelect} value={_value}>
        {types.map((t) => {
          return (
            <Option key={t.name} value={t.name}>
              {t.displayName}
            </Option>
          );
        })}
      </Select>
    </div>
  );
}
